module.exports = __webpack_public_path__ + "static/media/WhiteCheck.e107f7cb.svg";